/* Convert YYYY-MM-DD string to JS date at hour 0 **/
export const formatDateStringToDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number)
  return new Date(year, month - 1, day)
}
